<template>
  <v2-product-detail-content
    presentation="page"
    :product-id="$route.params.id"
    :collection-id="$route.params.collectionId"
    :wishlist-id="$route.params.wishlistId"
  />
</template>

<script>
import V2ProductDetailContent from './V2ProductDetailContent.vue'

export default {
  name: 'V2ProductDetails',
  components: {
    V2ProductDetailContent,
  },
}
</script>
